import { useRouter } from 'expo-router';
import { Pressable } from 'react-native';
import { Text } from '../../../components/primitives';
import { colors } from '../../../theme/colors';
import { withOriginHref } from '../../../utils/originHref';
import { useCalendarReturnHref } from './CalendarReturnHref';

interface OpenLeadLinkProps {
  leadId: string | null | undefined;
  testID: string;
  /** Runs before navigation — a modal host closes itself here. */
  onNavigate?: () => void;
}

// An agent-booked meeting is a rep's cue to read the lead before dialling
// back. The event already carries the lead id, so the preview and the edit
// form both offer the jump; an event with no lead renders nothing at all
// rather than a dead control.
export function OpenLeadLink({ leadId, testID, onNavigate }: Readonly<OpenLeadLinkProps>) {
  const router = useRouter();
  const returnHref = useCalendarReturnHref();

  if (!leadId) return null;

  const target = `/lead/${leadId}`;
  const href = returnHref ? withOriginHref(target, returnHref) : target;

  return (
    <Pressable
      testID={testID}
      accessibilityRole="button"
      accessibilityLabel="Open lead"
      hitSlop={8}
      onPress={(e) => {
        // A chip's preview sits inside a pressable cell; the jump must not
        // also drill the calendar into Day view.
        e?.stopPropagation?.();
        onNavigate?.();
        router.push(href as never);
      }}
    >
      <Text variant="caption" color={colors.primary[500]} style={{ fontWeight: '600' }}>
        Open lead →
      </Text>
    </Pressable>
  );
}
